import { render, staticRenderFns } from "./HotUpdateItem.vue?vue&type=template&id=cf5de23e&"
import script from "./HotUpdateItem.vue?vue&type=script&lang=js&"
export * from "./HotUpdateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf5de23e')) {
      api.createRecord('cf5de23e', component.options)
    } else {
      api.reload('cf5de23e', component.options)
    }
    module.hot.accept("./HotUpdateItem.vue?vue&type=template&id=cf5de23e&", function () {
      api.rerender('cf5de23e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/home/components/HotUpdateItem.vue"
export default component.exports